<template>
    <div class="">

        <!--<inertia-link
            v-if="stepAboveThree"
            :href="route('tenant.survey.preview', {survey: surveyModel.id})"
            title="Preview Survey"
            class="mr-auto ml-7 flex items-center font-bold text-lg leading-6"
            aria-label="Preview Survey"
        >
            <svg class="mr-2 w-6 h-6" fill="dark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"/>
            </svg>
            Preview Survey
        </inertia-link>-->
        <survey-editor-step-one v-if="step === 1"
                                @next-step="nextStep"
                                :step-title="stepTitle"
                                :step="step"
        />

        <survey-editor-step-two v-if="step === 2"
                                :survey-model="surveyModel"
                                :default-logo="defaultLogo"
                                :default-intro-text="defaultIntroText"
                                :default-profile-fields="defaultProfileFields"
                                :unit-prices="unitPrices"
                                @next-step="nextStep"
                                :step-title="stepTitle"
                                :step="step"
        />

        <survey-editor-step-three v-if="step === 3"
                                  :survey-model="surveyModel"
                                  @next-step="nextStep"
                                  @prev-step="prevStep"
                                  :step-title="stepTitle"
                                  :step="step"
        />

        <survey-editor-step-four v-if="step === 4"
                                 :survey-model="surveyModel"
                                 :default-email-text="defaultEmailText"
                                 @next-step="nextStep"
                                 @prev-step="prevStep"
                                 :step-title="stepTitle"
                                 :step="step"
        />

        <survey-price-calculator v-if="step === 5"
                                 :survey-model="surveyModel"
                                 :unit-prices="unitPrices"
                                 @prev-step="prevStep"
                                 :step-title="stepTitle"
                                 :step="step"
        />
    </div>

</template>

<script>
import SurveyEditorStepOne from "@/Components/SurveyEditor/SurveyEditorStepOne";
import SurveyEditorStepTwo from "@/Components/SurveyEditor/SurveyEditorStepTwo";
import SurveyEditorStepThree from "@/Components/SurveyEditor/SurveyEditorStepThree";
import SurveyEditorStepFour from "@/Components/SurveyEditor/SurveyEditorStepFour";
import SurveyPriceCalculator from "@/Components/SurveyPriceCalculator";
import JetButton from "@/Jetstream/Button";
import {computed, ref} from "vue";
import survey from "@/Components/Survey";

export default {
    name: "SurveyEditor",
    components: {
        SurveyPriceCalculator,
        SurveyEditorStepFour,
        SurveyEditorStepThree,
        SurveyEditorStepTwo,
        SurveyEditorStepOne,
        JetButton
    },
    props: {
        surveyModel: Object,
        defaultLogo: Object,
        defaultIntroText: String,
        defaultEmailText: String,
        defaultProfileFields: Array,
        queryStep: Number | String,
        surveyTypes: Array,
        unitPrices: Array,
    },
    setup(props) {
        const step = ref(!props.surveyModel ? 1 : parseInt(props.queryStep) || 2);

        const nextStep = () => {
            scrollToTop();
            step.value += 1;
        }

        const prevStep = () => {
            if (step.value > 2) {
                scrollToTop();
                step.value -= 1;
            }
        }

        const scrollToTop = () => {
            document.getElementById('mainContent').scrollTop = 0;
        }

        const stepAboveThree = computed(() => {
            return step.value > 2;
        })

        const stepTitle = computed(() => {
            switch (step.value) {
                case 1:
                    return "Select diagnostic type";
                case 2:
                    return "Customise";
                case 3:
                    return "Survey questions";
                case 4:
                    return "Invite survey participants";
                case 5:
                    return "Payment";
            }
        })

        return {
            step,
            nextStep,
            prevStep,
            stepAboveThree,
            stepTitle,
        }
    }
}
</script>

<style lang="scss">
@import "../../sass/ck-editor-dark";
@import "../../sass/ck-content";
</style>
